import AllTransaction from "./AllTransaction";

export default AllTransaction;